import useAuth from '@/hooks/use-auth/use-auth';
import {loadFollowedArtists, setFollowing} from '@/redux/actions/artistsFollowedActions';
import {STATUS_FAILED, STATUS_IDLE} from '@/redux/actionTypes';
import {selectFollowedState} from '@/redux/reducers/artistsFollowedReducer';
import {emit} from '@/utils/events';
import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {StyledFollowButton} from './styles';
import {Props} from './typings';

const FollowButton = ({
  artistId,
  artistSlug,
  artistName,
  followingCount,
  type,
  className,
}: Props) => {
  const auth = useAuth();
  const dispatch = useDispatch();
  const {data: followedArtists, status: followedStatus} = useSelector(selectFollowedState);
  const [following, setFollowingState] = useState(false);
  const [loading, setLoading] = useState(false);

  const toggleFollow = () => {
    console.log('>>> authenticated', auth.isAuthenticated());
    if (!auth.isAuthenticated()) {
      emit('CLICK_ON_JOIN');
      return;
    }
    setLoading(true);

    const cleanupCallbacks = [
      () => {
        setLoading(false);
      },
    ];

    dispatch(setFollowing(artistId, artistSlug, !following, cleanupCallbacks));
  };

  const countFilter = (count) => {
    if (count < 1000) {
      return count;
    } else if (count % 1000 === 0) {
      return `${count / 1000}K`;
    } else {
      return `${Math.floor(count / 100) / 10}K+`;
    }
  };

  useEffect(() => {
    if (followedStatus === STATUS_IDLE || followedStatus === STATUS_FAILED)
      dispatch(loadFollowedArtists());
  }, []);

  useEffect(() => {
    const isFollowing = followedArtists.includes(artistSlug);
    if (isFollowing !== following) {
      setFollowingState(isFollowing);
    }
  }, [followedArtists]);

  return (
    <StyledFollowButton
      className={className}
      active={following}
      disabled={loading}
      onClick={toggleFollow}
      icon="heart"
      title={following ? `Unfollow ${artistName}` : `Follow ${artistName}`}
      size={type === 'small' ? 'small' : 'default'}
      $size={type ?? 'default'}
      children={
        type === 'text'
          ? `${following ? 'Following' : 'Follow'}${
              followingCount ? ` (${countFilter(followingCount)})` : ''
            }`
          : undefined
      }
    />
  );
};

export default FollowButton;
